var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.titles[0].num
        ? _c(
            "title-block",
            { attrs: { id: "bm0" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[0].label)),
              ]),
              _c(
                "div",
                { staticClass: "mt-10" },
                [
                  _vm._l(_vm.platform, function (item) {
                    return _c(
                      "el-tag",
                      {
                        key: item,
                        staticClass: "mr-5 mb-5",
                        attrs: { type: "info", effect: "plain" },
                      },
                      [_vm._v(" " + _vm._s(item) + " ")]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "center" },
                    [
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.personnel.pageNum,
                          total: _vm.personnel.total,
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, 2)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.titles[1].num
        ? _c(
            "title-block",
            { attrs: { id: "bm1" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[1].label)),
              ]),
              _c(
                "div",
                { staticClass: "mt-10" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.record.tableData,
                        border: "",
                        "header-cell-style": {
                          background: "#fafafa",
                          color: "#333",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "人员姓名",
                          prop: "changeTime",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(_vm._s(scope.row.changeTime || "--")),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          142957102
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "职位",
                          prop: "changeItem",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(_vm._s(scope.row.changeItem || "--")),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2814379470
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "简介",
                          prop: "changeItem",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(_vm._s(scope.row.changeItem || "--")),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2814379470
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "center" },
                    [
                      _c("pagination", {
                        attrs: { total: _vm.record.total },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, 3)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.titles[2].num
        ? _c(
            "title-block",
            { attrs: { id: "bm2" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[2].label)),
              ]),
              _c(
                "div",
                { staticClass: "tables mt-10" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.personnel.tableData,
                        border: "",
                        "header-cell-style": {
                          background: "#fafafa",
                          color: "#333",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: "产品名称",
                          prop: "name",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.name || "--"))]
                              },
                            },
                          ],
                          null,
                          false,
                          1808752378
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "产品标签",
                          prop: "typeJoin",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.typeJoin &&
                                  scope.row.typeJoin.length > 0
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(scope.row.typeJoin.join("，"))
                                        ),
                                      ])
                                    : _c("div", [_vm._v("--")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2752187894
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "产品官网",
                          prop: "name",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.name || "--"))]
                              },
                            },
                          ],
                          null,
                          false,
                          1808752378
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "产品简介",
                          prop: "name",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.name || "--"))]
                              },
                            },
                          ],
                          null,
                          false,
                          1808752378
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "所属公司",
                          prop: "name",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.name || "--"))]
                              },
                            },
                          ],
                          null,
                          false,
                          1808752378
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "center" },
                    [
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.personnel.pageNum,
                          total: _vm.personnel.total,
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.handleCurrentChange(val, 2)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }